import { Component, OnInit } from '@angular/core';
import {Block, BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-header4',
    templateUrl: './block-header4.component.html',
})

export class BlockHeader4Component extends BlockAbstractComponent implements OnInit {

    parseBlockId(block: Block) {
        if (block.data.isAnchor) {
            return this.block.data.text.toLowerCase().replace(/\s+/g, '-');
        } else {
            return 'heading-' + block.id
        }
    }

}
